import retina from 'retinajs';

window.addEventListener('load', retina);

setInterval(() => {
  retina($('img'));
  listenImagesAttributes();
}, 1000);


function listenImagesAttributes() {
  let images = document.querySelectorAll('img');

  if (! (images && images.forEach && typeof images.forEach === "function")) return;

  images.forEach((image) => {
    initListenerForImage(image);
  });
}

function initListenerForImage(image) {
  if(!$(image).attr('data-rjs')) return;

  let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

  let observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if ((mutation.type != 'attributes') || (mutation.attributeName != 'src')) return;

      let src = $(mutation.target).attr('src');

      if (src && src.indexOf('@2x') !== -1) return;

      $(mutation.target).removeAttr('data-rjs-processed');
    });
  });

  observer.observe(image, {
    attributes: true,
  });
}